"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDropdown = void 0;
const react_1 = require("@floating-ui/react");
function useDropdown(placement, matchWidth = false, strategy) {
    return (0, react_1.useFloating)({
        middleware: [
            (0, react_1.flip)(),
            (0, react_1.shift)(),
            (0, react_1.size)({
                apply({ availableHeight, availableWidth, elements }) {
                    Object.assign(elements.floating.style, {
                        maxHeight: Math.min(240, availableHeight) + "px",
                        maxWidth: matchWidth
                            ? Math.min(availableWidth, elements.reference.getBoundingClientRect().width) + "px"
                            : availableWidth,
                    });
                },
            }),
        ],
        placement,
        strategy,
        whileElementsMounted: (reference, floating, update) => (0, react_1.autoUpdate)(reference, floating, update, {
            elementResize: typeof ResizeObserver !== "undefined",
        }),
    });
}
exports.useDropdown = useDropdown;
